// extracted by mini-css-extract-plugin
export var active = "MultiModal-module--active--2499d";
export var closeButton = "MultiModal-module--closeButton--d203e";
export var content = "MultiModal-module--content--19e19";
export var eventLink = "MultiModal-module--eventLink--c9d39";
export var liveDot = "MultiModal-module--liveDot--ccac3";
export var modalPadding = "5px";
export var multiModal = "MultiModal-module--multiModal--443b5";
export var notification = "MultiModal-module--notification--e1584";
export var notificationArea = "MultiModal-module--notificationArea--7d65e";
export var overlay = "MultiModal-module--overlay--8c3cd";
export var resizeIcon = "MultiModal-module--resizeIcon--20db3";
export var resizer = "MultiModal-module--resizer--27e53";
export var sportIcon = "MultiModal-module--sportIcon--e21d3";
export var sportIconWrapper = "MultiModal-module--sportIconWrapper--1bb36";
export var title = "MultiModal-module--title--e6206";
export var titleHeight = "60px";
export var titleText = "MultiModal-module--titleText--4beeb";
export var titleWrapper = "MultiModal-module--titleWrapper--0d29c";
export var totalAdditionalWindowHeight = "65px";
export var vsBadge = "MultiModal-module--vsBadge--3e198";